import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Route, Switch, Redirect, Match } from 'react-router-dom';


import 'font-awesome/css/font-awesome.min.css';
import 'simple-line-icons/css/simple-line-icons.css';
import '../scss/style.scss'
import '../scss/core/_dropdown-menu-right.scss'

import Full from './containers/Full/'

import AuthenticatedRoute from './AuthenticatedRoute/'


import Login from './views/Pages/Login/'
import Locked from './views/Pages/Locked/'
import Register from './views/Pages/Register/'
import Page404 from './views/Pages/Page404/'
import Page500 from './views/Pages/Page500/'

import ChangePassword from './views/Pages/ChangePassword/ChangePassword.js'
import ForgottenPassword from './views/Pages/ChangePassword/ForgottenPassword.js'

import { DragDropContextProvider } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'

import auth from './auth/'
import api from './api/'
import config from './config'

const setMetaContent = (name, content) => {
  const meta = document.querySelector(`meta[name="${name}"]`);
  if (meta) meta.setAttribute('content', content);
};

document.title = config.NOMBRE;
setMetaContent('description', config.DESCRIPCION);
setMetaContent('author', config.AUTOR);
setMetaContent('version', config.VERSION);
window.BASE_URL = config.BASE_URL;

ReactDOM.render((
  <DragDropContextProvider backend={HTML5Backend}>
    <HashRouter>
      <Switch>
        <Route exact path="/login" name="Login Page" component={Login} />
        <Route exact path="/register" name="Register Page" component={Register} />
        <Route exact path="/404" name="Page 404" component={Page404} />
        <Route exact path="/500" name="Page 500" component={Page500} />
        <AuthenticatedRoute exact path="/locked" name="Locked Page" component={Locked} />
        <AuthenticatedRoute exact path="/changepassword" name="Change Password" component={ChangePassword} />
        <Route exact path="/forgottenpassword" name="Forgotten Password" component={ForgottenPassword} />
        <AuthenticatedRoute path="/"
          component={Full}
          onCheck={res => {
            if (res) {

              // localStorage.linea1 = res.config.linea1;
              // localStorage.linea2 = res.config.linea2;
              // localStorage.linea3 = res.config.linea3;
              if (res.is_staff) {
                return window.location.origin + "/admin/";
              } else if (res.changePasswordOnLog)
                return "/changepassword";
            }
            return false;
          }}
        />
      </Switch>
    </HashRouter>
  </DragDropContextProvider>

), document.getElementById('root'))


// WEBPACK FOOTER //
// ./src/index.js